// extracted by mini-css-extract-plugin
export default {"circleSpinner":"CircleSpinner_circleSpinner__clzYd","image":"CircleSpinner_image__x6MLr","spinAnimation":"CircleSpinner_spinAnimation__BQnn-"};